import { TPrivacyPolicyProps } from './types'
import cn from 'classnames'

const PrivacyAction = ({ newTab, className }: TPrivacyPolicyProps) => {
  const handleAction = (e) => {
    e.stopPropagation()
    e.preventDefault()
    window.open(
      'https://www.owens-minor.com/privacy-policy/',
      newTab ? '_blank' : '_self'
    )
  }
  return (
    <span
      className={cn(className, 'privacy-action')}
      role="button"
      onClick={handleAction}
    >
      Privacy Policy
    </span>
  )
}

export default PrivacyAction
